const ITEMS = [
  { text: "Precision Engineered", sep: false },
  { text: "·", sep: true },
  { text: "CNC Aluminium", sep: false },
  { text: "·", sep: true },
  { text: "LED Technology", sep: false },
  { text: "·", sep: true },
  { text: "360° Adjustable", sep: false },
  { text: "·", sep: true },
  { text: "Free Worldwide Shipping", sep: false },
  { text: "·", sep: true },
  { text: "2-Year Warranty", sep: false },
  { text: "·", sep: true },
  { text: "Expert Support", sep: false },
  { text: "·", sep: true },
  { text: "30-Day Returns", sep: false },
  { text: "·", sep: true },
];

function Carousel() {
  return (
    <div className="cr-strip">
      <div className="cr-track">
        {[...Array(2)].map((_, rep) => (
          <span key={rep} style={{ display: "inline-flex" }}>
            {ITEMS.map((item, i) => (
              <span key={i} className={`cr-item${item.sep ? " sep" : ""}`}>
                {item.text}
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Carousel;
